import DataAPI from "@/classes/DataAPI";
import { emitter } from "@/services/emitter";

// Singleton DataAPI instance. Construction happens at module evaluation, so
// any consumer that imports `API` from here gets the fully-initialised
// instance once this module has finished loading.
//
// Note: DataAPI imports `@/store`, and store.js previously imported `API`
// back from `@/main` — that load-time cycle is what triggered the TDZ
// error during HMR. Now `store.js` never accesses `API` at module-load
// (uses are deferred into actions / `initializeStoreSideEffects`), so the
// `apiInstance → DataAPI → store → apiInstance` cycle is safe.
export const API = new DataAPI(emitter);
